var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sport-container"},[_c('sport-header',{attrs:{"sport":_vm.sport}}),_vm._l((_vm.sport.matchIds),function(matchId){return _c('match',{key:matchId,attrs:{"match-id":matchId}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }